import axios from 'axios';

// Use environment variable or fallback to relative API path
const baseURL = import.meta.env.VITE_API_URL || '/api/';

const axiosClient = axios.create({
    baseURL: baseURL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    withCredentials: true // Important for CORS with cookies
});

// Request Interceptor
axiosClient.interceptors.request.use((config) => {
    config.headers = config.headers || {};

    // Add CSRF token for state-changing requests only
    if (['post', 'put', 'patch', 'delete'].includes(config.method.toLowerCase())) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
            config.headers['X-CSRF-TOKEN'] = csrfToken;
        }
    }

    return config;
});

// Response Interceptor
axiosClient.interceptors.response.use(
    (response) => {
        alertMessage(response.data);
        return response;
    },
    (error) => {
        if (error.response) {
            alertMessage(error.response.data);

            // Handle 401 Unauthorized (session expired or not logged in)
            if (error.response.status === 401 && window.location.pathname !== '/logout') {
                window.location.replace('/logout');
            }
        }
        return Promise.reject(error);
    }
);

// Toast Notification Handler (uses SweetAlert2 toast mode — no jQuery/toastr needed)
function alertMessage(data) {
    if (!data.message) return;

    const showToast = (msg, isSuccess) => {
        import('sweetalert2').then(({ default: Swal }) => {
            window.Swal = Swal;
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: isSuccess ? 'success' : 'error',
                title: msg,
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
            });
        });
    };

    if (Array.isArray(data.message)) {
        data.message.forEach((msg) => showToast(msg, data.success));
    } else {
        showToast(data.message, data.success);
    }
}

export default axiosClient;
